/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import Header from "./header"
import Footer from "./footer"
import "./layout.scss"

const isBrowser = typeof window !== 'undefined';
const firebase = isBrowser ? require('firebase/app') : 'div';

if (typeof window !== "undefined" && !firebase.apps.length) {
  // Your web app's Firebase configuration
  var firebaseConfig = {
    apiKey: "AIzaSyBy9TVdwj3HyZlDt1JDN9heMJ1JgM4eaNc",
    authDomain: "university-f294c.firebaseapp.com",
    databaseURL: "https://university-f294c.firebaseio.com",
    projectId: "university-f294c",
    storageBucket: "university-f294c.appspot.com",
    messagingSenderId: "632853848390",
    appId: "1:632853848390:web:5db4f3a61021af4f074547",
    measurementId: "G-K3G4MFHZW8"
  }
  // Initialize Firebase
  firebase.initializeApp(firebaseConfig);
}

const Layout = ( props ) => {
  return (
    <>
      <Header path={ props.path } />
      
      <main>{ props.children }</main>
      
      <Footer />
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
